module.exports = __webpack_public_path__ + "static/media/health-normal.0da85e24.svg";